import { formatTripDateRange } from "../../helpers/dates";

import currencyFormatter from "../../helpers/currencyFormatter";
import formatStage from "../../helpers/format-stage";

const formatOperatorOption = ({ operatorName, _id }) => ({
  label: operatorName,
  value: _id,
});

const formatProspectOption = ({
  _id,
  firstAndLastName,
  lastName,
  firstName,
  emails,
  companyName,
  assigneeId,
  assigneeName,
}) => {
  let name = firstAndLastName || [firstName, lastName].filter(Boolean).join(" ").trim();
  let label = `${name} - ${emails[0]}`;

  if (companyName) {
    label = `${label} - ${companyName}`;
  }

  if (assigneeName && assigneeId) {
    label = `${label} - ${assigneeName}`;
  }

  return {
    value: _id,
    label,
  };
};

const formatTripOption = ({ _id, tripTag, firstDepartureDate, routing, lastArrivalDate, clientId, clientName }) => ({
  value: _id,
  label: [
    tripTag,
    formatTripDateRange(firstDepartureDate, lastArrivalDate),
    routing ?? "-",
  ].filter(Boolean).join(" | "),
  clientId: clientId || null,
  clientName: clientName || null,
});

const formatContractOption = (
  {
    _id,
    contractTag,
    clientName,
    clientId,
    legs,
    pricing,
    trip,
  },
  includeTripInfo = false,
) => ({
  value: _id,
  label: [
    ...(
      includeTripInfo ?
        [
          trip?.tripTag,
          formatTripDateRange(trip?.firstDepartureDate, trip?.lastArrivalDate),
          trip?.routing ?? "-",
        ] :
        []
    ),
    contractTag,
    clientName,
    legs?.[0]?.aircraft?.name,
    pricing?.flightCharges ? currencyFormatter.format(pricing.flightCharges) : null,
  ].filter(Boolean).join(" | "),
  clientId: clientId || null,
  clientName: clientName || null,
  trip: trip || null,
});

const formatOFROption = (
  {
    _id,
    ofrTag,
    operator,
    aircraft,
    operatorPrice,
    trip,
  },
  includeTripInfo = false,
) => ({
  value: _id,
  label: [
    ...(
      includeTripInfo ?
        [
          trip?.tripTag,
          formatTripDateRange(trip?.firstDepartureDate, trip?.lastArrivalDate),
          trip?.routing ?? "-",
        ] :
        []
    ),
    ofrTag,
    operator?.name,
    aircraft?.name,
    operatorPrice ? currencyFormatter.format(operatorPrice) : null,
  ].filter(Boolean).join(" | "),
});

const formatGroupedOptionsByStage = (data, formatter, ...rest) =>
  Object.entries(
    Object.groupBy(data, item => item.stage),
  ).map(
    ([stage, data]) => ({
      label: formatStage(stage),
      options: data.map(item => formatter(item, ...rest)),
      priority: Math.min(
        ...data.map((i) => (Number.isFinite(i?.priority) ? i.priority : Number.POSITIVE_INFINITY)),
      ),
    }),
  ).sort(
    (a, b) => a.priority - b.priority,
  ).map(
    ({ label, options }) => ({ label, options }),
  );

export {
  formatOperatorOption,
  formatProspectOption,
  formatTripOption,
  formatContractOption,
  formatOFROption,
  formatGroupedOptionsByStage,
};
